module.exports = "/client/static/images/browser-edge.36f25504.svg";